/** @jsxImportSource @emotion/react */
'use memo'

import css from '@emotion/css/macro'
import { Tooltip } from 'antd'
import colors from '@sportninja/common/constants/appColors'
import { capitalizeWords } from '@sportninja/common/ts-utils'
import { TEAM_FINDER_SUPPORT_URL } from '@sportninja/common/features/teamFinder/constants'
import QuestionIcon from 'src/components/icons/QuestionIcon'
import BetaBadge from 'src/components/ts-components/BetaBadge'
import Text from 'src/components/ts-components/Text'
import { paragraphMedium } from 'src/components/css'

// Matches the My Schedule page header: a large uppercase display title, with a
// short helper line beneath it explaining what the page is for. The help icon
// mirrors the Family Management header — same tooltip + external support link.
const TeamFinderHeader = () => (
  <div css={wrapStyle}>
    <div css={titleRowStyle}>
      <Text
        variant='heading1'
        weight='semiBold'
        color={colors.NEUTRAL_0}
        style='text-transform: uppercase;'
      >
        {capitalizeWords('Team Finder')}
      </Text>
      <BetaBadge />
      <Tooltip title={capitalizeWords('How Team Finder Works')}>
        <a
          css={infoButtonStyle}
          href={TEAM_FINDER_SUPPORT_URL}
          target='_blank'
          rel='noopener noreferrer'
          aria-label='Learn more about the Team Finder'
        >
          <QuestionIcon size={22} color={colors.PRIMARY} />
        </a>
      </Tooltip>
    </div>
    <p css={subtitleStyle}>
      If you&apos;re looking to join a team yourself, this is where you do it.
    </p>
  </div>
)

export default TeamFinderHeader

const wrapStyle = css`
  display: flex;
  flex-direction: column;
  gap: 8px;
`
const titleRowStyle = css`
  display: flex;
  align-items: center;
  gap: 8px;
`
const subtitleStyle = css`
  ${paragraphMedium};
  color: ${colors.NEUTRAL_50};
  margin: 0;
`
const infoButtonStyle = css`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  line-height: 0;

  &:hover {
    opacity: 0.85;
  }
`
